import request from './request';

export function getMessageList(params) {
  return request.get('/api/message/list', { params });
}
export function getUnreadCount() {
  return request.get('/api/message/unreadCount');
}
export function readMessage(id) {
  return request.post('/api/message/read', { id });
}
export function readAllMessages(type) {
  return request.post('/api/message/readAll', { type });
}
export function sendMessage(toUserId, content) {
  return request.post('/api/message/send', { to_user_id: toUserId, content });
}
export function getConversations() {
  return request.get('/api/message/conversation');
}
export function getConversationDetail(params) {
  return request.get('/api/message/conversationDetail', { params });
}
